import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'
import { PerformanceStrategyConfigurationInput } from 'generated/resources/graphql'

import { useFormContext } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import type { Form } from 'modules/performance_process/components/score_configuration_weights/ScoreWeightsSidepanel'
import { orderStrategies } from 'modules/performance_process/lib/reviewStrategy'

import { MissingStrategyWeightCallout } from './MissingStrategyWeightCallout'
import { NoScoreState } from './NoScoreState'

type Props = {
  strategy: PerformanceReviewerStrategiesStrategyEnum
  navigateToStrategyWeight: () => void
  children: React.ReactNode
}

export const StrategyConfigurationGuard = ({
  strategy,
  navigateToStrategyWeight,
  children,
}: Props) => {
  const form = useFormContext<Form>()
  const configuration = form.values.configurationByStrategy[strategy]

  const handleProduceScoreChange = (producesScore: boolean) => {
    if (!configuration) {
      return null
    }

    const newConfiguration: PerformanceStrategyConfigurationInput = {
      ...configuration,
      producesScore,
    }
    form.setFieldValue(`configurationByStrategy.${strategy}`, newConfiguration)
  }

  if (!configuration) {
    return children
  }

  if (!configuration.producesScore) {
    return (
      <NoScoreState
        strategy={strategy}
        strategies={orderStrategies(Object.keys(form.values.configurationByStrategy))}
        onAddScore={() => handleProduceScoreChange(true)}
      />
    )
  }

  if (!configuration?.weight) {
    return (
      <Box gap="s24" flexDirection="column">
        <MissingStrategyWeightCallout
          strategy={strategy}
          onNavigateToStrategyWeight={navigateToStrategyWeight}
        />

        {children}
        <Box flexDirection="row" justifyContent="flexEnd">
          <Button type="secondary" onClick={() => handleProduceScoreChange(false)}>
            {i18n.t('performance_process.score_strategy_weights.remove_score')}
          </Button>
        </Box>
      </Box>
    )
  }

  return children
}
